__turbopack_context__.v({
  "customCursor": "VAvE9W_customCursor",
  "emblaContainer": "VAvE9W_emblaContainer",
  "emblaContainerInner": "VAvE9W_emblaContainerInner",
  "emblaSlide": "VAvE9W_emblaSlide",
  "emblaViewport": "VAvE9W_emblaViewport",
  "galleryImage": "VAvE9W_galleryImage",
  "imageWrapper": "VAvE9W_imageWrapper",
  "section": "VAvE9W_section",
});
